import { CompanyInvitationRole, Role } from '__generated__/GQL';

import { GetBeneficiariesDataQuery } from '../graphql/queries/getBeneficiariesData.gql';

const getIsMissingAccountHolder = (
  data: Pick<GetBeneficiariesDataQuery['viewer'], 'company' | 'companyUser'>,
) => {
  const { roles } = data.companyUser;

  if (roles.includes(Role.AccountHolder)) {
    return false;
  }

  const { legalBeneficiaries } = data.company;

  return legalBeneficiaries.every(
    (legalBeneficiary) =>
      legalBeneficiary.invitation?.role !== CompanyInvitationRole.AccountHolder,
  );
};

export default getIsMissingAccountHolder;
